export default {
  hasAgent(state) {
    return !!(state.agentInfo && state.agentInfo.has_agent);
  },

  agentName(state) {
    return state.agentInfo ? state.agentInfo.agent_name : "";
  },

  canSend(state) {
    return !state.isStreaming;
  }
};
